import React, {PropsWithChildren, ReactNode} from "react";

import {IFieldState} from "../../types";
import {FieldLabel} from "../FieldLabel";
import {FieldMessage} from "../FieldMessage";

import {labelStyle} from "./FieldWrapper.module.css";

export interface IFieldWrapperProps
    extends PropsWithChildren<{
        labelContent?: string | ReactNode;
        htmlFor?: string;
        message?: string;
        fieldState?: IFieldState;
        className?: string;
        onClick?: (e: React.MouseEvent) => void;
        required?: boolean;
        dataTestId?: string;
        afterChildren?: ReactNode;
    }> {}

export const FieldWrapper = (props: IFieldWrapperProps) => {
    const {children, labelContent, htmlFor, message, fieldState, onClick, required, dataTestId, afterChildren} = props;

    const parseMessage = (message?: string) => {
        if (!message) {
            return null;
        }
        if (message.includes("\n")) {
            const messages = message.split("\n");
            return messages.map((message) => (
                <FieldMessage key={message} fieldState={fieldState}>
                    {message}
                </FieldMessage>
            ));
        }
        return <FieldMessage fieldState={fieldState}>{message}</FieldMessage>;
    };

    return (
        <div className={props.className} onClick={onClick} data-testid={dataTestId}>
            {labelContent && (
                <FieldLabel className={labelStyle} htmlFor={htmlFor}>
                    {required ? "*" : ""}
                    {labelContent}
                </FieldLabel>
            )}

            {children}
            {afterChildren}
            {parseMessage(message)}
        </div>
    );
};
import React, {PropsWithChildren, ReactNode} from "react";

import {IFieldState} from "../../types";
import {FieldLabel} from "../FieldLabel";
import {FieldMessage} from "../FieldMessage";

import {labelStyle} from "./FieldWrapper.module.css";

export interface IFieldWrapperProps
    extends PropsWithChildren<{
        labelContent?: string | ReactNode;
        htmlFor?: string;
        message?: string;
        fieldState?: IFieldState;
        className?: string;
        onClick?: (e: React.MouseEvent) => void;
        required?: boolean;
        dataTestId?: string;
        afterChildren?: ReactNode;
    }> {}

export const FieldWrapper = (props: IFieldWrapperProps) => {
    const {children, labelContent, htmlFor, message, fieldState, onClick, required, dataTestId, afterChildren} = props;

    const parseMessage = (message?: string) => {
        if (!message) {
            return null;
        }
        if (message.includes("\n")) {
            const messages = message.split("\n");
            return messages.map((message) => (
                <FieldMessage key={message} fieldState={fieldState}>
                    {message}
                </FieldMessage>
            ));
        }
        return <FieldMessage fieldState={fieldState}>{message}</FieldMessage>;
    };

    return (
        <div className={props.className} onClick={onClick} data-testid={dataTestId}>
            {labelContent && (
                <FieldLabel className={labelStyle} htmlFor={htmlFor}>
                    {required ? "*" : ""}
                    {labelContent}
                </FieldLabel>
            )}

            {children}
            {afterChildren}
            {parseMessage(message)}
        </div>
    );
};
